export default function kebabToCamelCase(string) {
    return string.replace(/-./g, x => x[1].toUpperCase());
}
